import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotesComponent } from './notes.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';

@NgModule({
  declarations: [NotesComponent],
  imports: [
    CommonModule,
    FormsModule,
    OverlayPanelModule,
    CalendarModule,
    TableModule,
    NgScrollbarModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    PipeDirectiveModule,
  ],
  exports: [NotesComponent],
})
export class GenaricNotesModule {}
